const defaults = {
  htmlContent: '',
  fileName: 'document.pdf',
  pageSize: 'A4',
  orientation: 'portrait',
  marginTop: 20,
  marginBottom: 20,
  marginLeft: 20,
  marginRight: 20,
};

export default defaults;
